module.exports = __webpack_public_path__ + "img/saint-lucia.3f3cb028.svg";